import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/saquelog';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageSaques() {
  return (
    <Root title={PAGE_TITLE.SAQUES}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
